module.exports = __webpack_public_path__ + "s.no1.f2605cc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/s.no1.jpg
// module id = oz5r
// module chunks = 0